import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment"


@Injectable({
    providedIn: "root"
})
export class StateService {

    public dashboard = true; //true;

    constructor() {
        if (localStorage.dashboard) {
            this.dashboard = true; //Boolean(localStorage.dashboard);
        }
    }

    setDashboard(dashboard: boolean) {
        localStorage['dashboard'] = dashboard;
        this.dashboard = true; //dashboard;
    }
}